import { Injectable } from "@angular/core";
import { FirebaseApp, getApps, initializeApp } from "firebase/app";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private app: FirebaseApp;

  constructor() {
    if (!getApps().length) {
      console.log("[Push] Firebase Initial App");
      this.app = initializeApp(environment.firebase);
    } else {
      this.app = this.getApp();
    }
  }

  getApp() {
    return this.app;
  }
}
